import axios from 'axios';
import { defaultEndPointDetails } from '../utils/const.utils';

export const getAvailableLiquidityApi = (sourceCabnId, sourceNetworkId, token) => {
    return axios.get(`${defaultEndPointDetails.baseUrl}/api/v1/community-member/multiSwap/liquidity/avaialable?sourceCabnId=${sourceCabnId}&sourceNetworkId=${sourceNetworkId}`,{
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`
      }
  });
}